// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const messageBroadcast_donateText = (i) => `Auch <b class="font-semibold">uns kostet der SMS und Email versand leider Geld</b>, daher würden wir uns über 1€ Spende pro Nachricht freuen.`